import { render } from "./Agreement3View.vue?vue&type=template&id=1047c7d1"
import script from "./Agreement3View.vue?vue&type=script&lang=js"
export * from "./Agreement3View.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__